import type { FC } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { Box, Button, Link } from '@mui/material'
import KeyIcon from '@mui/icons-material/Key'
import { Link as RouterLink } from 'react-router-dom'
import { WizardHeader } from '@/common/components'

const DAEMON_SETUP_ROUTE = '/docs/daemon-setup'

interface WelcomeStepProps {
  readonly onNext: () => void
  readonly onClose: () => void
}

export const WelcomeStep: FC<WelcomeStepProps> = ({ onNext, onClose }) => {
  return (
    <>
      <WizardHeader
        icon={<KeyIcon />}
        title="Generate API Key"
        description="Required by our daemon to authenticate with the backend"
        largeDescription
      />
      <Box sx={linkContainerSx}>
        <Link component={RouterLink} to={DAEMON_SETUP_ROUTE} onClick={onClose} sx={linkSx}>
          Learn how to set up the daemon
        </Link>
      </Box>
      <Box sx={buttonContainerSx}>
        <Button variant="contained" onClick={onNext} sx={buttonSx}>
          Get Started
        </Button>
      </Box>
    </>
  )
}

const linkContainerSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
}

const linkSx: SxProps<Theme> = {
  fontSize: '0.875rem',
  color: 'primary.main',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
}

const buttonContainerSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  mt: 4,
}

const buttonSx: SxProps<Theme> = {
  minWidth: 160,
}
